import { StyleSheet } from 'aphrodite';
import { destructive, titles, warningDark } from '../../../styles/colors';
import { CssSelectors, Layouts, cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	// The RegEd questionnaire runs long enough to push the submit button past the viewport, so the
	// form scrolls inside the dialog rather than the dialog growing past it.
	reviseDialogForm: {
		maxHeight: '60vh',
		minHeight: 0,
		overflowY: 'auto',
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		gap: 10,
		justifyContent: 'center',
	},
	actionsVertical: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		...Layouts.verticalStack(10),
		...CssSelectors.allChildren(
			{
				marginRight: 0,
			},
			'button'
		),
	},
	approvalStatusTitle: {
		color: warningDark,
		fontSize: 14,
		lineSpacing: '1.1px',
		textAlign: 'left',
		textTransform: 'uppercase',
	},
	approvedStatusDate: {
		alignItems: 'flex-end',
		fontSize: 14,
		lineSpacing: '1.1px',
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	approvedStatusTitle: {
		color: '#89C947',
		fontSize: 14,
		lineSpacing: '1.1px',
		textAlign: 'left',
		textTransform: 'uppercase',
	},
	buttonActions: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 10,
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			'button'
		),
	},
	cancelButton: {
		flex: 1,
	},
	cancelInstructions: {
		color: destructive,
		fontSize: 14,
	},
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		color: '#4a4a4a',
		fontSize: 14,
		marginTop: 20,
		padding: '15px 20px',
	},
	cardActions: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			'button'
		),
	},
	cardTitle: {
		color: titles,
		fontSize: 16,
		margin: '0 0 6px',
	},
	scheduleDateActions: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: 6,
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			'button'
		),
	},
	container: {
		...Layouts.verticalStack(20),
		overflowY: 'auto',
	},
	complianceButtons: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 10,
		...CssSelectors.allChildren(
			{
				fontSize: 14,
				marginBottom: 8,
			},
			'button'
		),
	},
	// Zero the link buttons' horizontal padding so their envelope icons sit flush with the card's left edge,
	// lining up with the "Compliance Approval" title and "Pending Approval" status above them. The Button's
	// size styles set padding under a `:has(> svg)` selector, so we must override at the same specificity.
	complianceLinkButton: {
		paddingLeft: 0,
		paddingRight: 0,
		':has(> svg)': {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	complianceIcon: {
		marginRight: 10,
	},
	complianceInputGroup: {
		// The InputGroup is a `div`, not a `button`, so `complianceButtons`' `> button` spacing rule does not
		// reach it — give the row its own bottom gap to match the surrounding link buttons.
		marginBottom: 8,
		maxWidth: 320,
	},
	previewContentTitle: {
		fontSize: 16,
	},
	recipientsCard: {
		fontSize: 14,
	},
	sideHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	socialContainer: {
		...Layouts.verticalStack(20),
	},
	tagList: {
		marginTop: 15,
	},
});
